export enum FormType{
   corporate = 'Corporate',
   retail = 'Retail Store'
}